import fetch from '@/utils/fetch'

// 统计实时处理量
export function getTaskCapacity() {
  return fetch({
    url: '/api/artificial/statistics/user/capacity',
    method: 'get'
  })
}

/**
 * 按时间统计处理量
 * @param {*} type 时间类型 0: 今日 1: 昨日 2: 本月 3: 上月
 */
export function getTaskStatistics(type) {
  return fetch({
    url: `/api/artificial/statistics/user/homeStat/${type}`,
    method: 'get'
  })
}

/**
 * 按时间统计排行榜
 * @param {*} type 时间类型 0: 今日 1: 昨日 2: 本月 3: 上月
 */
export function getTaskRanking(type) {
  return fetch({
    url: `/api/artificial/statistics/ranking/${type}`,
    method: 'get'
  })
}

/**
 * 按时间统计分布图
 * @param {*} type 时间类型 0: 今日 1: 昨日 2: 本月 3: 上月
 */
export function getTaskProfile(type) {
  return fetch({
    url: `/api/artificial/statistics/user/profile/${type}`,
    method: 'get'
  })
}

/**
 * 处理员统计待处理任务数量
 */
export function getUndoneTaskCount() {
  return fetch({
    url: '/api/artificial/task/abnlOrder/undoneCount',
    method: 'get',
  })
}

// 开始练习
export function startPractice(data) {
  return fetch({
    url: '/api/artificial/abnl/user/train/startTrain',
    method: 'post',
    data
  })
}

// 查询接单状态
export function getPauseOrderCheck() {
  return fetch({
    url: '/api/artificial/task/abnlOrder/crowd/pauseOrderCheck',
    method: 'get'
  })
}
